const EQUALWEB_SHADOW_HOST_SELECTORS = ['#INDShadowRootHost', '#INDshadowRootWrap'];

const HIDE_EW_MENU_BTN =
  '#INDmenu-btn{position:fixed!important;left:-10000px!important;top:0!important;width:1px!important;height:1px!important;opacity:0!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;clip-path:inset(50%)!important;white-space:nowrap!important;border:0!important;padding:0!important;margin:0!important;}';

const EW_OFFSCREEN_STYLE_ID = 'equalweb-launch-offscreen';

const EARLY_HIDE_TIMEOUT_MS = 15000;

type EqualWebApi = {
  menu?: HTMLElement;
  a11y?: { a11yBtn?: HTMLElement };
};

function getEqualWebApi(): EqualWebApi | undefined {
  return ((window as unknown) as { interdeal?: EqualWebApi }).interdeal;
}

// a partir do core 5.3.1 o shadow root da EqualWeb é "closed" (host.shadowRoot vem null);
// o interdeal.menu é o #INDmenu dentro dele, então o getRootNode() devolve o próprio shadow root.
// O a11yBtn mora no mesmo shadow root e pode existir antes do menu.
export function getEqualWebShadowRoot(): ShadowRoot | null {
  const api = getEqualWebApi();
  const root = (api?.menu ?? api?.a11y?.a11yBtn)?.getRootNode?.();
  return root instanceof ShadowRoot ? root : null;
}

export function collectEqualWebShadowRoots(): ShadowRoot[] {
  const roots = EQUALWEB_SHADOW_HOST_SELECTORS.reduce<ShadowRoot[]>((acc, selector) => {
    const host = document.querySelector(selector) as
      | (HTMLElement & { shadowRoot?: ShadowRoot })
      | null;
    if (host?.shadowRoot) acc.push(host.shadowRoot);
    return acc;
  }, []);

  const closedRoot = getEqualWebShadowRoot();
  if (closedRoot && !roots.includes(closedRoot)) roots.push(closedRoot);

  return roots;
}

function findEqualWebButton(): HTMLElement | null {
  const fromApi = getEqualWebApi()?.a11y?.a11yBtn;
  if (fromApi) return fromApi;

  const direct = document.getElementById('INDmenu-btn') as HTMLElement | null;
  if (direct) return direct;

  return collectEqualWebShadowRoots().reduce<HTMLElement | null>(
    (found, root) => found ?? root.querySelector<HTMLElement>('#INDmenu-btn'),
    null,
  );
}

export function installEqualWebLaunchButtonOffscreenStyle(): void {
  if (typeof document === 'undefined') return;

  if (!document.getElementById(EW_OFFSCREEN_STYLE_ID)) {
    const inDoc = document.createElement('style');
    inDoc.id = EW_OFFSCREEN_STYLE_ID;
    inDoc.textContent = HIDE_EW_MENU_BTN;
    document.head.appendChild(inDoc);
  }

  collectEqualWebShadowRoots().forEach(shadowRoot => {
    if (shadowRoot.getElementById(EW_OFFSCREEN_STYLE_ID)) return;
    const s = document.createElement('style');
    s.id = EW_OFFSCREEN_STYLE_ID;
    s.textContent = HIDE_EW_MENU_BTN;
    shadowRoot.appendChild(s);
  });
}

// O EqualWeb desenha o próprio botão assim que o script roda; esconder só no onload (e nas
// tentativas espaçadas do vlibras.ts) deixava o botão piscar por cima do loading.
// O rAF roda antes de cada pintura, então nenhum frame chega a mostrá-lo. Para quando o
// botão existe: o estilo entrou no mesmo tick no head e na raiz dele (shadow root).
export function hideEqualWebLaunchButtonUntilReady(): void {
  if (typeof window === 'undefined' || typeof window.requestAnimationFrame !== 'function') return;

  const startedAt = Date.now();
  const tick = (): void => {
    installEqualWebLaunchButtonOffscreenStyle();
    if (findEqualWebButton() || Date.now() - startedAt >= EARLY_HIDE_TIMEOUT_MS) return;
    window.requestAnimationFrame(tick);
  };

  tick();
}

export const showEqualWebDrawer = (): void => {
  installEqualWebLaunchButtonOffscreenStyle();
  const button = findEqualWebButton();
  if (button) button.click();
};
